/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './external.defs.js'
export { main as default } from './external.defs.js'
